import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "../../boutons/button/button.component";
import { DialogRef } from '@angular/cdk/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirm-modal',
  imports: [ButtonComponent],
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['../modal-styles.scss',  './confirm-modal.component.scss']
})
export class ConfirmModalComponent {

  @Input() content:string | Subscription = `Vous ne pourrez pas revenir en arrière.`;
  @Input() title:string = `Êtes-vous sûr ?`;
  @Input() confirm:string = `oui`;
  @Input() cancel:string = `non`;
  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private dialogRef: DialogRef
  ) {}

  protected closeModal(): void {
    this.dialogRef.close()
  }
}
